import { render, staticRenderFns } from "./PopupAddAutomation.vue?vue&type=template&id=6515c819&scoped=true&"
import script from "./PopupAddAutomation.vue?vue&type=script&lang=js&"
export * from "./PopupAddAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515c819",
  null
  
)

export default component.exports